export const SKILLS = [
  "Eye Contact", "Voice Projection", "Problem Solving", "Adaption to Change", "Listening",
  "Focus", "Quick Thinking", "Creative Thinking", "Attention To Detail", "Teamwork",
];
